export default __webpack_public_path__ + "static/media/tapume.78521aeb.png";